import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export class ConferencesOverviewSlider {
    constructor() {
        this.swiperElement = document.querySelector('[data-swiper="conferences-overview"]');
    }

    init() {
        if (!this.swiperElement) {
            return;
        }
        new Swiper(this.swiperElement, {
            modules: [Navigation, A11y],
            slidesPerView: 1,
            spaceBetween: 16,
            centerInsufficientSlides: false,
            a11y: {
                scrollOnFocus: false,
            },
            navigation: {
                nextEl: '.swiper-conferences-button-next',
                prevEl: '.swiper-conferences-button-prev',
                addIcons: true,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                },
            },
        });
    }
}
